module.exports = __webpack_public_path__ + "img/file-edit.f2c15955.png";